import React from 'react';
import { IDeviceSelectorList } from './DeviceSelectorList';

interface IProps extends IDeviceSelectorList {}

export const DeviceSelectorListNative:React.FC<IProps> = ({
  deviceList, selectedDevice, onDeviceSelected, deviceType,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    onDeviceSelected(deviceType, e.target.value);
  };

  return (
    <select
      className="myinterview-widget-select-native"
      value={selectedDevice?.deviceId}
      onChange={handleChange}
    >
      {deviceList?.map((device) => (
        <option
          key={device.deviceId}
          value={device.deviceId}
        >
          {device.label}
        </option>
      ))}
    </select>
  );
};
